import React from "react";

const CancalationRefundPolicy = () => {
  return <div>CancalationRefundPolicy</div>;
};

export default CancalationRefundPolicy;
